import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, ApiError } from "@/api/client";
import type { Profile } from "@/api/types";
import { useSession } from "@/state/session";

export function Profiles() {
  const { account, selectProfile, refreshAccount } = useSession();
  const navigate = useNavigate();
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState("");
  const [isKids, setIsKids] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function create(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    try {
      const created = await api.post<Profile>("/api/v1/auth/profiles", {
        name,
        is_kids: isKids,
      });
      await refreshAccount();
      selectProfile(created);
      navigate("/home");
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : "Could not create the profile");
    }
  }

  return (
    <main className="profiles">
      <div style={{ textAlign: "center" }}>
        <h1>Who is watching?</h1>
        <div className="profiles__grid">
          {account?.profiles.map((profile) => (
            <button
              key={profile.id}
              type="button"
              className="profiles__item"
              onClick={() => {
                selectProfile(profile);
                navigate("/home");
              }}
            >
              <span className="avatar avatar--lg">{profile.name.slice(0, 1).toUpperCase()}</span>
              <span>{profile.name}</span>
              {profile.is_kids && <span className="chip">Kids</span>}
            </button>
          ))}

          {!adding && (
            <button type="button" className="profiles__item" onClick={() => setAdding(true)}>
              <span
                className="avatar avatar--lg"
                style={{ background: "var(--ink-300)", color: "var(--paper-300)" }}
              >
                +
              </span>
              <span>Add profile</span>
            </button>
          )}
        </div>

        {adding && (
          <form className="panel panel--narrow" onSubmit={create} style={{ marginTop: 32 }}>
            {error && <div className="alert alert--error">{error}</div>}
            <div className="field">
              <label htmlFor="profile-name">Profile name</label>
              <input
                id="profile-name"
                required
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </div>
            <label style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 18 }}>
              <input
                type="checkbox"
                checked={isKids}
                onChange={(event) => setIsKids(event.target.checked)}
              />
              <span>Kids profile (restricts mature titles)</span>
            </label>
            <button className="btn btn--accent btn--block" type="submit">
              Create profile
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
